import React, {useState} from 'react';
import {checkInMember, logGuest} from '../../api/calls';
import Container from 'react-bootstrap/Container';
import ActionBar from '../../components/ActionBar/ActionBar';
import MembersTable from '../../components/MembersTable/MembersTable';
import CheckInModal from '../../components/CheckInModal/CheckInModal';
import GuestModal from '../../components/GuestModal/GuestModal';
import AllGuestsModal from '../../components/AllGuestsModal/AllGuestsModal';
import AllCheckInsModal from '../../components/AllCheckInsModal/AllCheckInsModal';
import MemberChangesModal from '../../components/MemberChangesModal/MemberChangesModal';
import styles from './MembersListForManager.module.scss';

const MembersListForManager = ({ members }) => {
    const [search, setSearch] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [showGuestModal, setShowGuestModal] = useState(false);
    const [guestMember, setGuestMember] = useState(null);
    const [showAllGuestsModal, setShowAllGuestsModal] = useState(false);
    const [showAllCheckInsModal, setShowAllCheckInsModal] = useState(false);
    const [showMemberChangesModal, setShowMemberChangesModal] = useState(false);

    return (
        <Container className={styles.Wrapper}>
            <h2 className="text-center mb-3">Members List</h2>

            <ActionBar searchKeywords={search}
                       onChangeSearch={setSearch} />

            <MembersTable data={members}
                          userType="manager"
                          emailFilter={true}
                          keywords={search}
                          showModal={() => setShowModal(true)}
                          setSelectedMember={setSelectedMember}
                          showGuestModal={() => setShowGuestModal(true)}
                          setGuestMember={setGuestMember}
                          showAllGuestsModal={() => setShowAllGuestsModal(true)}
                          showAllCheckInsModal={() => setShowAllCheckInsModal(true)}
                          showMemberChangesModal={() => setShowMemberChangesModal(true)} />

            <CheckInModal show={showModal}
                          userType="manager"
                          member={selectedMember}
                          onCheckIn={checkInMember}
                          onHide={() => setShowModal(false)} />

            <GuestModal show={showGuestModal}
                        member={guestMember}
                        onSave={logGuest}
                        userType="manager"
                        onHide={() => setShowGuestModal(false)} />

            <AllGuestsModal show={showAllGuestsModal}
                            members={members}
                            onHide={() => setShowAllGuestsModal(false)} />

            <AllCheckInsModal show={showAllCheckInsModal}
                              members={members}
                              onHide={() => setShowAllCheckInsModal(false)} />

            <MemberChangesModal show={showMemberChangesModal}
                                onHide={() => setShowMemberChangesModal(false)} />
        </Container>
    );
};

export default MembersListForManager;
